// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3lUFJ","item":"PaymentsMobile_item__quIs2","label":"PaymentsMobile_label__3TAMs","amount":"PaymentsMobile_amount__2AR5t"};